import { Compliance } from '@/components/compliance-page';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const CompliancePage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Compliance</title>
      </Head>
      <Compliance />
    </>
  );
};

export default CompliancePage;
